export enum DeviceTypeEnum{
  WEB = 'WEB',
  MOBILE = 'MOBILE',
}
